/**
 * Initializes the cookiePopup by dynamically importing the necessary module.
 * If cookie-popup element is not found on the page, the function will exit early.
 *
 * @throws Will throw an error if the cookiePopup initialization fails.
 */
export const initializeCookiePopup = async (): Promise<void> => {
  const cookiePopupElement =
    document.querySelector<HTMLDivElement>('#cookiePopup');

  if (!cookiePopupElement) return; // Exit if the cookie-popup element is not found

  try {
    const { cookiePopup } = await import('../components/cookie-popup');

    cookiePopup.init();
  } catch (error: unknown) {
    // eslint-disable-next-line no-console
    console.error('🚨 Error initializing cookiePopup:', error);

    throw new Error(
      `Failed to initialize cookiePopup: ${
        error instanceof Error ? error.message : String(error)
      }`,
    );
  }
};
